import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { isChunkLoadError, reloadForNewVersion } from './utils/chunkReload';

window.addEventListener('unhandledrejection', (event) => {
  if (isChunkLoadError(event.reason)) {
    event.preventDefault();
    reloadForNewVersion();
  }
});

window.addEventListener('load', () => {
  window.setTimeout(() => {
    try {
      sessionStorage.removeItem('naewaste-chunk-reload');
    } catch (err) {
      // ignore
    }
  }, 15000);
});

// Check if React DevTools is installed in development
if (process.env.NODE_ENV === 'development') {
  const isDevToolsInstalled = window.__REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (!isDevToolsInstalled) {
    console.info(
      'For a better development experience, install React DevTools: ' +
      'https://reactjs.org/link/react-devtools'
    );
  }
}

// Register Service Worker for PWA
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  // When a new SW takes over, reload once so clients leave stale HTML/JS behind.
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('Service Worker registered successfully:', registration.scope);
        registration.update();

        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (!newWorker) return;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // Activate immediately so controllerchange reload can run.
              newWorker.postMessage({ type: 'SKIP_WAITING' });
              console.log('New service worker available; activating.');
            }
          });
        });
      })
      .catch((error) => {
        console.error('Service Worker registration failed:', error);
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 